import React from "react";
import { Box, Chip, Typography } from "@mui/material";

const PRIMARY = "var(--portal-theme-primary, #04abbb)";
const PRIMARY_SOFT =
  "color-mix(in srgb, var(--portal-theme-primary) 12%, white)";
const BORDER = "#e2e8f0";
const MUTED = "#64748b";

/**
 * Toggle chips for a journey tag vocabulary.
 * `value` is the selected tag list; `options` is the allowed vocabulary.
 */
export default function TagChipPicker({
  options = [],
  value = [],
  onChange,
  disabled = false,
  emptyLabel = "No tags on this journey yet. Add them under Tracker → Tags (from the Tags library).",
  label = "",
}) {
  const selected = Array.isArray(value) ? value : [];
  const selectedLower = new Set(selected.map((t) => String(t).toLowerCase()));
  const vocab = Array.from(
    new Set(
      (Array.isArray(options) ? options : [])
        .map((t) => String(t || "").trim())
        .filter(Boolean)
    )
  );

  const toggle = (tag) => {
    if (disabled || !onChange) return;
    const key = tag.toLowerCase();
    if (selectedLower.has(key)) {
      onChange(selected.filter((t) => String(t).toLowerCase() !== key));
    } else {
      onChange([...selected, tag]);
    }
  };

  return (
    <Box>
      {label ? (
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 700,
            color: MUTED,
            mb: 0.75,
            textTransform: "uppercase",
            letterSpacing: 0.35,
          }}
        >
          {label}
        </Typography>
      ) : null}
      {vocab.length === 0 ? (
        <Typography sx={{ fontSize: 13, color: MUTED }}>{emptyLabel}</Typography>
      ) : (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
          {vocab.map((tag) => {
            const active = selectedLower.has(tag.toLowerCase());
            return (
              <Chip
                key={tag}
                label={tag}
                size="small"
                clickable={!disabled}
                disabled={disabled}
                onClick={() => toggle(tag)}
                sx={{
                  fontWeight: 600,
                  border: `1px solid ${active ? PRIMARY : BORDER}`,
                  bgcolor: active ? PRIMARY_SOFT : "#fff",
                  color: active ? PRIMARY : "#334155",
                  opacity: disabled ? 0.6 : 1,
                }}
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
}
